/** 액션별 대시보드 탭. v0.1 §8.1.
 *
 * 탭 순서: 전체 → Q&A → 회의록 → 요약 → 분석 → 제안 → 기타
 * 선택은 localStorage 에 저장하여 새로고침 후에도 유지.
 */
import { useEffect } from "react";
import type { TabKey } from "@/lib/types";

const TABS: { key: TabKey; label: string }[] = [
  { key: "all", label: "전체" },
  { key: "qa", label: "Q&A" },
  { key: "meeting", label: "회의록" },
  { key: "summary", label: "요약" },
  { key: "analyze", label: "분석" },
  { key: "propose", label: "제안" },
  { key: "etc", label: "기타" },
];

const STORAGE_KEY = "arkiveai:monitor:activeTab";

interface Props {
  value: TabKey;
  onChange: (next: TabKey) => void;
}

export function ActionTabs({ value, onChange }: Props) {
  // 마운트 시 localStorage 값 적용
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY) as TabKey | null;
    if (saved && saved !== value && TABS.some((t) => t.key === saved)) {
      onChange(saved);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handle = (next: TabKey) => {
    localStorage.setItem(STORAGE_KEY, next);
    onChange(next);
  };

  return (
    <nav
      className="flex flex-wrap gap-1 rounded-md border bg-card p-1 text-sm"
      role="tablist"
      aria-label="액션 분류 탭"
    >
      {TABS.map((t) => {
        const active = t.key === value;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => handle(t.key)}
            className={
              "rounded px-3 py-1.5 transition-colors " +
              (active
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-muted")
            }
          >
            {t.label}
          </button>
        );
      })}
    </nav>
  );
}
